module.exports = __webpack_public_path__ + "img/room-04.f9392427.jpg";